import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientAucDoses(patientId: string | undefined) {
  return useQuery(queries.patients.getPatientAucDoses(patientId || ''))
}
